// extracted by mini-css-extract-plugin
export default {"container":"MatchEvents_container__qurbj","name":"MatchEvents_name__TaeHO","time":"MatchEvents_time__xz4N+"};